import React from 'react';

const HeroGraphic = () => {
  return (
    <div className="relative w-full h-full min-h-[500px] flex items-center justify-center">
      {/* Main SVG Container */}
      <svg
        viewBox="0 0 500 500"
        className="w-full max-w-lg h-auto"
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Background Circles */}
        <circle
          cx="250"
          cy="250"
          r="200"
          fill="none"
          stroke="url(#gradient1)"
          strokeWidth="1"
          opacity="0.3"
          className="animate-pulse-slow"
        />
        <circle
          cx="250"
          cy="250"
          r="160"
          fill="none"
          stroke="url(#gradient1)"
          strokeWidth="1"
          opacity="0.4"
          className="animate-pulse-slow animation-delay-500"
        />
        <circle
          cx="250"
          cy="250"
          r="120"
          fill="none"
          stroke="url(#gradient1)"
          strokeWidth="1.5"
          opacity="0.5"
          className="animate-pulse-slow animation-delay-1000"
        />

        {/* Central Shield */}
        <g className="animate-float">
          <path
            d="M250 140 L310 170 L310 250 C310 300 250 340 250 340 C250 340 190 300 190 250 L190 170 Z"
            fill="url(#shieldGradient)"
            stroke="#06b6d4"
            strokeWidth="2"
            className="drop-shadow-glow"
          />
          {/* Lock Icon inside shield */}
          <rect x="230" y="220" width="40" height="35" rx="4" fill="#0f172a" />
          <path
            d="M238 220 L238 205 C238 195 262 195 262 205 L262 220"
            fill="none"
            stroke="#0f172a"
            strokeWidth="6"
            strokeLinecap="round"
          />
          <circle cx="250" cy="237" r="5" fill="#06b6d4" />
          <rect x="248" y="237" width="4" height="10" fill="#06b6d4" />
        </g>

        {/* Orbiting Nodes */}
        <g className="animate-orbit">
          <circle cx="250" cy="50" r="12" fill="#06b6d4" className="animate-pulse" />
          <circle cx="250" cy="50" r="6" fill="#0f172a" />
        </g>
        
        <g className="animate-orbit-reverse">
          <circle cx="450" cy="250" r="10" fill="#14b8a6" className="animate-pulse animation-delay-300" />
          <circle cx="450" cy="250" r="5" fill="#0f172a" />
        </g>
        
        <g className="animate-orbit animation-delay-700">
          <circle cx="50" cy="250" r="10" fill="#06b6d4" className="animate-pulse animation-delay-500" />
          <circle cx="50" cy="250" r="5" fill="#0f172a" />
        </g>
        
        <g className="animate-orbit-reverse animation-delay-1000">
          <circle cx="250" cy="450" r="12" fill="#14b8a6" className="animate-pulse animation-delay-700" />
          <circle cx="250" cy="450" r="6" fill="#0f172a" />
        </g>

        {/* Corner nodes */}
        <g className="animate-float animation-delay-300">
          <circle cx="100" cy="100" r="8" fill="#0891b2" opacity="0.8" />
          <line x1="100" y1="100" x2="180" y2="180" stroke="#0891b2" strokeWidth="1" opacity="0.4" strokeDasharray="4 4" />
        </g>
        
        <g className="animate-float animation-delay-700">
          <circle cx="400" cy="100" r="8" fill="#14b8a6" opacity="0.8" />
          <line x1="400" y1="100" x2="320" y2="180" stroke="#14b8a6" strokeWidth="1" opacity="0.4" strokeDasharray="4 4" />
        </g>
        
        <g className="animate-float animation-delay-500">
          <circle cx="100" cy="400" r="8" fill="#14b8a6" opacity="0.8" />
          <line x1="100" y1="400" x2="180" y2="320" stroke="#14b8a6" strokeWidth="1" opacity="0.4" strokeDasharray="4 4" />
        </g>
        
        <g className="animate-float animation-delay-1000">
          <circle cx="400" cy="400" r="8" fill="#0891b2" opacity="0.8" />
          <line x1="400" y1="400" x2="320" y2="320" stroke="#0891b2" strokeWidth="1" opacity="0.4" strokeDasharray="4 4" />
        </g>

        {/* Connection Lines */}
        <path
          d="M250 140 Q350 100 400 100"
          fill="none"
          stroke="url(#lineGradient)"
          strokeWidth="1.5"
          opacity="0.6"
          strokeDasharray="200"
          className="animate-dash"
        />
        <path
          d="M250 140 Q150 100 100 100"
          fill="none"
          stroke="url(#lineGradient)"
          strokeWidth="1.5"
          opacity="0.6"
          strokeDasharray="200"
          className="animate-dash animation-delay-500"
        />

        {/* Gradients */}
        <defs>
          <linearGradient id="gradient1" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#06b6d4" />
            <stop offset="100%" stopColor="#14b8a6" />
          </linearGradient>
          <linearGradient id="shieldGradient" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#0891b2" stopOpacity="0.9" />
            <stop offset="100%" stopColor="#0d9488" stopOpacity="0.9" />
          </linearGradient>
          <linearGradient id="lineGradient" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stopColor="#06b6d4" stopOpacity="0" />
            <stop offset="50%" stopColor="#06b6d4" stopOpacity="1" />
            <stop offset="100%" stopColor="#14b8a6" stopOpacity="0" />
          </linearGradient>
          <filter id="glow">
            <feGaussianBlur stdDeviation="3" result="coloredBlur" />
            <feMerge>
              <feMergeNode in="coloredBlur" />
              <feMergeNode in="SourceGraphic" />
            </feMerge>
          </filter>
        </defs>
      </svg>

      {/* Floating particles */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        {[...Array(12)].map((_, i) => (
          <div
            key={i}
            className="absolute w-2 h-2 rounded-full bg-cyan-500/30 animate-float-particle"
            style={{
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              animationDelay: `${i * 0.3}s`,
              animationDuration: `${3 + Math.random() * 2}s`
            }}
          />
        ))}
      </div>
    </div>
  );
};

export default HeroGraphic;
